// Helpers liés à la page d'Accueil (route '/' = Main.tsx).
//
// L'Accueil est masqué dans ces cas :
//   - Grand Utilisateur (prefs.grand_utilisateur) : sait où il va, on l'envoie direct au catalogue
//   - Single Customer (un seul client en base, cf. useIsSingleCustomerLocal) : pas de choix possible
//   - Retail-only (pas d'accès bijoux : user-client, N1/N2, etc.) : pas d'accès au dashboard
//     Accueil → catalogue. Cf. useCanSeeJewelry (seuls admin / internal non-manager y ont droit).
//
// Quand l'Accueil est masqué, tout lien/redirection vers '/' doit être remplacé par '/catalog'.

import usePrefStore from '../stores/prefs'
import useIsSingleCustomerLocal from './useIsSingleCustomerLocal'
import { computeCanSeeJewelry } from './useCanSeeJewelry'

/** True si la page d'Accueil ('/') est accessible pour le user courant. */
export function useIsHomeAvailable(): boolean {
   const isGrandUtilisateur = usePrefStore((s) => s.isGrandUtilisateur)
   const retailRole = usePrefStore((s) => s.retailRole)
   const serverRetailRole = usePrefStore((s) => s.serverRetailRole)
   const isRetailManager = usePrefStore((s) => s.isRetailManager)
   const prefsLoaded = usePrefStore((s) => s.prefsLoaded)
   const isSingleCustomer = useIsSingleCustomerLocal()
   // Retail-only (pas d'accès bijoux) → pas d'Accueil.
   const canSeeJewelry = computeCanSeeJewelry(retailRole, serverRetailRole, isRetailManager, prefsLoaded)
   return !isGrandUtilisateur && !isSingleCustomer && canSeeJewelry
}

/**
 * Route à utiliser comme destination "par défaut" :
 *  - Accueil dispo → '/'
 *  - Accueil masqué → '/catalog'
 */
export function useDefaultLandingRoute(): '/' | '/catalog' {
   return useIsHomeAvailable() ? '/' : '/catalog'
}

/** Version pure (hors React) pour les call sites qui n'ont pas accès aux hooks. */
export function computeIsHomeAvailable(isGrandUtilisateur: boolean, isSingleCustomer: boolean): boolean {
   return !isGrandUtilisateur && !isSingleCustomer
}
